/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Range_6_MonthsInputs */

const en_dashboard_range_6_months = /** @type {(inputs: Dashboard_Range_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 6 months`)
};

const pt_br2_dashboard_range_6_months = /** @type {(inputs: Dashboard_Range_6_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 6 meses`)
};

/**
* | output |
* | --- |
* | "Last 6 months" |
*
* @param {Dashboard_Range_6_MonthsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_range_6_months = /** @type {((inputs?: Dashboard_Range_6_MonthsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Range_6_MonthsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_range_6_months(inputs)
	return pt_br2_dashboard_range_6_months(inputs)
});